export default {
    'page.panels': {
        groupBy: 'type',
        useRefs: true,
    },
    'product.product_attributes': {
        groupBy: 'type',
        useRefs: true,
    },
    'product.categories': {
        useRefs: true,
    },
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/multi_select.js